import React from 'react';
import Modal from '../../../components/modal/modal';
import { Button, notify } from '../../../components';
import { deleteListing } from '../api';
import { format } from 'date-fns';
import { analyticEventLogger, convertCustomDateFormatToISO } from '../../../utils/commonUtils';
import { TICKET_DELETE_EVENT_CLICK } from '../../../constants/eventLogger';
import mixpanel from 'mixpanel-browser';

const DeleteModal = ({ listingId,ticket, onClose }) => {
  const formattedTime = ticket?.event?.payload?.start_date ? format(convertCustomDateFormatToISO(ticket?.event?.payload?.start_date), 'EEE, dd MMM yyyy, h:mm a') : null;

  const handleConfirm = () => {
    analyticEventLogger(TICKET_DELETE_EVENT_CLICK);
    deleteListing(listingId, () => {
      onClose();
      mixpanel.track("Listing_Deleted", {
        "event_id": ticket?.event?.id,
        "event_name": ticket?.event?.payload?.name,
        "user_id": ticket?.user,
        "listing_status": "Removed",
        "page_url": window.location.href,
      });
      notify('success', 'Listing deleted', {
        position: 'bottom-center',
        duration: 2000,
      });
    }, () => {
      notify('error', 'Failed to delete the listing', {
        position: 'bottom-center',
        duration: 2000,
      });
    });
  };

  return (
    <Modal className='delete-modal flex p-6 pb-5 items-center'>
      <div className='flex flex-col gap-6 md:px-8 md:py-7 p-6 pb-5 '>
        <div className='heading-24'>Are you sure you want to delete the listing?</div>
        <div className='flex flex-col md:flex-row gap-2'>
          <img
            src={ticket?.event?.payload?.image}
            alt={ticket?.event?.payload?.name}
            className='md:w-[126px] md:h-[72px] w-[290px] h-[160px] object-cover rounded-lg'
          />
          <div className='flex flex-col gap-1 pl-2'>
            <div className='heading-16'>{ticket?.event?.payload?.name}</div>
            <div className='text-16'>{formattedTime}</div>
            <div className='text-16'>{ticket.event?.payload?.venue}</div>
          </div>
        </div>
        <div className='flex flex-col-reverse gap-2 md:flex-row md:gap-5 w-full'>
          <Button onClick={onClose} 
            type='tertiary'
            className='w-full md:w-[200px]' >
              Cancel
          </Button>
          <Button onClick={handleConfirm}
            className='w-full md:w-[200px]' >
              Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
